import { isProductionDomain, isSandboxDomain } from "constants/domains";

const isGCXDomain = () => {
  const hostname = window.location.hostname;
  if (!hostname) return false;
  return isProductionDomain(hostname) || isSandboxDomain(hostname);
};

const handleChatWidget = () => {
  if (window.zE) {
    window.zE("messenger", "open");
  }
};

export { isGCXDomain, handleChatWidget };
